import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CardContainer } from '../components/ui/CardContainer';
import { PrimaryButton } from '../components/ui/PrimaryButton';
import { CheckCircleIcon } from '@phosphor-icons/react';
import { AuthLayout } from '../components/layout/AuthLayout';

export const AccountConfirmedPage = () => {
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <CardContainer>
        <div className="text-center">
          <CheckCircleIcon size={64} className="mx-auto mb-4 text-green-500" weight="fill" />
          <h1 className="text-3xl font-display text-primary mb-8">
            {t('auth.account_confirmed.title')}
          </h1>

          <Link to="/login">
            <PrimaryButton type="button">
              {t('auth.account_confirmed.cta.go_to_login')}
            </PrimaryButton>
          </Link>
        </div>
      </CardContainer>
    </AuthLayout>
  );
};
